import { render, staticRenderFns } from "./v-loading.vue?vue&type=template&id=fb841efe"
import script from "./v-loading.vue?vue&type=script&lang=js"
export * from "./v-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb841efe')) {
      api.createRecord('fb841efe', component.options)
    } else {
      api.reload('fb841efe', component.options)
    }
    module.hot.accept("./v-loading.vue?vue&type=template&id=fb841efe", function () {
      api.rerender('fb841efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/loading/v-loading.vue"
export default component.exports